import React, { Component } from 'react';
import { NonIdealState } from "@blueprintjs/core";
import { Pane } from "evergreen-ui";

class NotFound extends Component {

  render() {
    return (
      <Pane padding={20} margin={30} display={"flex"} flex={1}>
        <NonIdealState
          icon={"error"}
          title="404 - Not found"
          description={"Page you are trying to open does not exist"}
        />
      </Pane>
    );
  }

}

export default NotFound;
